module.exports = __webpack_public_path__ + "assets/img/IMG040.729f7f3b.png";